var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loyalty-progress"},_vm._l((_vm.total),function(index){return _c('div',{key:index,class:{ complete: index <= _vm.progress }})}))}
var staticRenderFns = []

export { render, staticRenderFns }